(function () {
  var SHOW_AFTER = 320;
  var button = document.getElementById('back-to-top');
  if (!button) return;

  var ticking = false;

  function updateVisibility() {
    var visible = window.scrollY > SHOW_AFTER;
    button.classList.toggle('back-to-top--visible', visible);
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateVisibility);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  updateVisibility();

  button.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
